import $  from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import './styles.scss';

export default class GiftManager{
	constructor(config,$modules){
			let props ={};
			props.packageId = config.packageId;
			props.promoId =config.promoId;
			props.formDisplay = config.formDisplay;
			props.emailHide = config.emailHide;
			props.officeRoadHide = config.officeRoadHide;
			props.officeCityHide = config.officeCityHide;
			props.stateHide = config.stateHide;
			props.zipHide = config.zipHide;
			props.countryHide = config.countryHide;
			let el = $modules;
			if (el === undefined) return;
			$modules.each((index, el) => {
            	ReactDOM.render(React.createElement(App, props), el);
        	});
       }
	}

GiftManager.selector = '[data-module="GiftManager"]';
GiftManager.init = (config,$modules) => {
	  $modules = $modules || $(GiftManager.selector);
	  	new GiftManager(config,$modules);
	}




// WEBPACK FOOTER //
// ./medscape_modules/gift-manager/index.js